<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import CustomList from "../../../../compositions/CustomList.vue";
import ModalDialog from "../../../../compositions/ModalDialog.vue";
import SearchBox from "../../../../compositions/SearchBox.vue";
import SelectBox from "../../../../compositions/SelectBox.vue";
import Chart from "../../../../compositions/Chart.vue";
import SummaryMedicineComponent from '../../../Common/SummaryMedicineComponent.vue';
import config from "../../../../config.js";
import { errorAlert } from "../../../../plugins/alert";
import { getFieldValue } from "../../../../plugins/utility";
import qs from 'qs';
import axios from '../../../../plugins/axios.ts';
import { deepCopy } from "../../../../plugins/utility";
import HelpAction from '../../../../compositions/HelpAction.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    identityId: {
      typ:Number,
      default:() => {
        return 0;
      }
    },
    searchParams: {
      typ:Object,
      default:() => {
        return {};
      }
    },
    isVisible:{
        type:Boolean,
        default: () => {
            return false;
        }
    }
})

const { isVisible,identityId,searchParams } = toRefs(props);
const listPharmacyRef = ref();
const chartHeight = ref(280);
const searchParamsData = reactive(props.searchParams);
const pharmacySummaryFields = reactive([
  {field_name: '薬局名', field_key: 'pharmacy_name', width: '15%', align: 'text-left',sorted:true},
  {field_name: '取引先名', field_key: 'target_pharmacy_name', width: '15%', align: 'text-left',sorted:true},
  {field_name: '採用品', field_key: 'product_detail_name', width: '20%', align: 'text-left',sorted:true},
  {field_name: '小分け購入金額(税込)', field_key: 'pack_buy_stock_price', width: '10%', align: 'text-center',sorted:true},
  {field_name: '小分け購入回数', field_key: 'pack_buy_stock_count', width: '10%', align: 'text-center',sorted:true},
  {field_name: '小分け販売金額(税込)', field_key: 'pack_sell_stock_price', width: '10%', align: 'text-center',sorted:true},
  {field_name: '小分け販売回数', field_key: 'pack_sell_stock_count', width: '10%', align: 'text-center',sorted:true},
]);

const summaryData = reactive([]);
const summaryChartData = reactive([]);
const summaryChartHistoryPriceData = reactive([]);
const summaryChartHistoryCountData = reactive([]);
const summaryHistoryType = ref(0);
const summaryHistoryOptions = reactive([
  {id:0,name:'取引先別'},
  {id:1,name:'薬局別'},
]);
const onSummaryHistoryTypeChange = (value,label) => {
  summaryHistoryType.value = value;
  getSummaryHistory();
}
const getSummary = async () => {
  let params = deepCopy(searchParamsData);
  const paramsSerializer = (params) => qs.stringify(params,{ arrayFormat: 'repeat'});
  let response = await axios.get(props.apis.summary_stock_pack_summary,{params:params,paramsSerializer});
  summaryData.splice(0);
  summaryData.push(response.data.summary);
}
const getSummaryHistory = async () => {
  let params = deepCopy(searchParamsData);
  params['history_type'] = summaryHistoryType.value;
  const paramsSerializer = (params) => qs.stringify(params,{ arrayFormat: 'repeat'});
  let response = await axios.get(props.apis.summary_stock_pack_summary_list,{params:params,paramsSerializer});
  let chartPriceRecord = {};
  let chartCountRecord = {};
  chartPriceRecord.labels = [];
  for (let i=0;i<response.data.list.length;i++) {
    chartPriceRecord.labels.push(response.data.list[i].summary_key);
  }
  chartHeight.value = 60 + chartPriceRecord.labels.length * 30; // 凡例の高さ分を足す
  chartPriceRecord.datasets = [];
  chartCountRecord.labels = [];
  for (let i=0;i<response.data.list.length;i++) {
    chartCountRecord.labels.push(response.data.list[i].summary_key);
  }
  chartCountRecord.datasets = [];
  let buy_price = [];
  let sell_price = [];
  let buy_count = [];
  let sell_count = [];
  for (let i=0;i<response.data.list.length;i++) {
    buy_price.push(response.data.list[i].pack_buy_stock_price);
    sell_price.push(response.data.list[i].pack_sell_stock_price);
    buy_count.push(response.data.list[i].pack_buy_stock_count);
    sell_count.push(response.data.list[i].pack_sell_stock_count);
  }
  chartPriceRecord.datasets.push({
      type:'bar',
      label:'購入',
      backgroundColor:'#2dc181',
      data:buy_price,
  });
  chartPriceRecord.datasets.push({
      type:'bar',
      label:'販売',
      backgroundColor:'#FF6384',
      data:sell_price,
  });
  chartCountRecord.datasets.push({
      type:'bar',
      label:'購入',
      backgroundColor:'#2dc181',
      data:buy_count,
  });
  chartCountRecord.datasets.push({
      type:'bar',
      label:'販売',
      backgroundColor:'#FF6384',
      data:sell_count,
  });

  summaryChartHistoryPriceData.splice(0);
  summaryChartHistoryPriceData.push(chartPriceRecord);
  summaryChartHistoryCountData.splice(0);
  summaryChartHistoryCountData.push(chartCountRecord);
}
///  小分け回数テーブル /////////////////
const listPharmacyCountRef = ref();
const searchCountParamsData = reactive(props.searchParams);
const pharmacySummaryCountFields = reactive([
  {field_name: '薬局名', field_key: 'pharmacy_name', width: '15%', align: 'text-left',sorted:true},
  {field_name: 'グループ外<br>小分け回数', field_key: 'pack_other_count', width: '15%', align: 'text-right',sorted:true},
  {field_name: '販売実績回数', field_key: 'pack_sell_count', width: '20%', align: 'text-right',sorted:true},
  {field_name: '購入実績回数', field_key: 'pack_buy_count', width: '10%', align: 'text-right',sorted:true},
]);

///////////////////////////////////////
const refreshView = (force=false) => {
  if (isVisible.value == false) {
    return;
  }
  if (typeof listPharmacyRef.value !== 'undefined' && listPharmacyRef.value != null) {
    listPharmacyRef.value.resetItem();
  }
  if (typeof listPharmacyCountRef.value !== 'undefined' && listPharmacyCountRef.value != null) {
    listPharmacyCountRef.value.resetItem();
  }
  getSummary();
  getSummaryHistory();
}
watch(isVisible,(newValue, oldValue) => {
  if (props.isVisible == false) {
    return;
  }
  if (newValue) {
    refreshView();
  }
})
watch(identityId,(newValue, oldValue) => {
  refreshView();
})
watch(searchParams,(newValue, oldValue) => {
  refreshView();
},{deep:true})
onMounted(() => {
  refreshView();
});
</script>

<style scoped>
.summary-header {
  min-height:54px;
}
.summary-chart {
  min-height:342px;
}
</style>
<template>
<div v-show="isVisible" class="relative">
  <div class="absolute top-2 left-2" style="z-index:39;">
    <help-action
      help-key="dashboard_pack_help"
    ></help-action>
  </div>
  <div class="pl-8 w-full border flex items-center justify-between px-4 summary-header" v-for="(summaryRecord,index) in summaryData" :key="index">
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">小分け購入金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.pack_buy_stock_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">小分け購入回数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.pack_buy_stock_count.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">小分け販売金額(税込み)</span></div>
      <div class="text-bold text-lg">\{{ summaryRecord.pack_sell_stock_price.toLocaleString() }}</div>
    </div>
    <div class="text-center">
      <div><span class="mx-4 border-b text-sm">小分け販売回数</span></div>
      <div class="text-bold text-lg">{{ summaryRecord.pack_sell_stock_count.toLocaleString() }}</div>
    </div>
  </div>
  <div class="w-full mt-1 flex flex-col summary-chart">
    <div class="w-full mt-1">
      <div class="w-1/5">
        <select-box
          :value="summaryHistoryType"
          :options="summaryHistoryOptions"
          :on-change="onSummaryHistoryTypeChange"
        ></select-box>
      </div>
    </div>
    <div class="w-full flex flex-col mt-1">
      <div v-for="(summaryChartHistoryRecord,index) in summaryChartHistoryPriceData" :key="index">
        <div class="font-bold">【金額】</div>
        <div>
          <chart
            chart-type="bar"
            :height="chartHeight + 'px'"
            :chart-data="summaryChartHistoryRecord"
            :chart-options="{responsive:true,indexAxis:'y',maintainAspectRatio: false}"
          ></chart>
        </div>
      </div>
      <div v-for="(summaryChartHistoryRecord,index) in summaryChartHistoryCountData" :key="index">
        <div class="font-bold">【回数】</div>
        <div>
          <chart
            chart-type="bar"
            :height="chartHeight + 'px'"
            :chart-data="summaryChartHistoryRecord"
            :chart-options="{responsive:true,indexAxis:'y',maintainAspectRatio: false}"
          ></chart>
        </div>
      </div>
    </div>
  </div>
  <div class="w-full mt-1 mb-5">
    <div class="font-bold">【小分け一覧】</div>
    <custom-list
      ref="listPharmacyRef"
      :api-url="apis.summary_stock_pack_list"
      :table-fields="pharmacySummaryFields"
      :option-fields="searchParamsData"
      :is-downloadable="true"
      font-size="0.8em"
      height="40vh"
    >
    <template v-slot:item="slotProps">
      <summary-medicine-component
        :apis="apis"
        :item="slotProps.item"
        :fields="pharmacySummaryFields"
      ></summary-medicine-component>
    </template>
    </custom-list>
  </div>
  <div class="w-full mt-1 mb-5">
    <div class="font-bold">【小分け取引回数一覧】</div>
    <div class="text-sm">※参考値として、小分け回数はグループ外薬局との売買実績の回数を表示しています。<br>ただし、グループ薬局内でも本システムを使用していない店舗はグループ外に含まれるためご了承ください。</div>
    <custom-list
      ref="listPharmacyCountRef"
      :api-url="apis.summary_stock_pack_count"
      :table-fields="pharmacySummaryCountFields"
      :option-fields="searchCountParamsData"
      :is-downloadable="true"
      font-size="0.8em"
      height="40vh"
    >
    <template v-slot:item="slotProps">
      <summary-medicine-component
        :apis="apis"
        :item="slotProps.item"
        :fields="pharmacySummaryCountFields"
      ></summary-medicine-component>
    </template>
    </custom-list>
  </div>
</div>
</template>
